export type ThemePreference = 'system' | 'light' | 'dark'

export const THEME_STORAGE_KEY = 'theme'
export const THEME_COOKIE = 'theme'
export const THEME_COOKIE_LEGACY = 'docs-theme'

export const THEME_CYCLE: readonly ThemePreference[] = ['system', 'dark', 'light']

const COOKIE_MAX_AGE = 60 * 60 * 24 * 365

export function nextTheme(current: ThemePreference): ThemePreference {
  const index = THEME_CYCLE.indexOf(current)
  return THEME_CYCLE[(index + 1) % THEME_CYCLE.length]
}

export function parseThemePreference(value: string | null | undefined): ThemePreference | null {
  if (value === 'system' || value === 'light' || value === 'dark') return value
  return null
}

export function readThemePreference(): ThemePreference {
  if (typeof window === 'undefined') return 'system'
  try {
    const stored = parseThemePreference(localStorage.getItem(THEME_STORAGE_KEY))
    if (stored) return stored
  } catch {
    /* ignore */
  }
  return 'system'
}

function writeThemeCookie(preference: ThemePreference): void {
  if (typeof document === 'undefined') return
  document.cookie = `${THEME_COOKIE}=${preference};path=/;max-age=${COOKIE_MAX_AGE};SameSite=Lax`
  document.cookie = `${THEME_COOKIE_LEGACY}=${preference};path=/;max-age=${COOKIE_MAX_AGE};SameSite=Lax`
}

export function applyTheme(preference: ThemePreference): void {
  const root = document.documentElement
  root.classList.remove('light', 'dark')
  if (preference === 'light' || preference === 'dark') {
    root.classList.add(preference)
  }
  try {
    localStorage.setItem(THEME_STORAGE_KEY, preference)
  } catch {
    /* ignore */
  }
  writeThemeCookie(preference)
}

/**
 * Blocking init injected into <head>. System leaves html without .light/.dark
 * so prefers-color-scheme still drives tokens. Explicit light/dark set a class.
 */
export const THEME_INIT_SCRIPT = `try{var d=document.documentElement,t=localStorage.getItem('theme');if(t!=='light'&&t!=='dark'&&t!=='system')t='system';d.classList.remove('light','dark');if(t==='light'||t==='dark')d.classList.add(t);document.cookie='theme='+t+';path=/;max-age=31536000;SameSite=Lax';document.cookie='docs-theme='+t+';path=/;max-age=31536000;SameSite=Lax'}catch(e){}`
